const containsOv = technologyAttributes => technologyAttributes.find(attribute => attribute.id === 'owefwefwefv')

export default containsOv